import { useTranslation } from 'react-i18next';

export default function ProductFilter({ categories, activeCategory, searchQuery, onCategoryChange, onSearchChange }) {
    const { t } = useTranslation();

    return (
        <div className="ast-product-filter">
            <div className="ast-product-filter__search">
                <input
                    type="text"
                    className="ast-input"
                    placeholder={t('catalog.search')}
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>

            <div className="ast-product-filter__categories">
                <button
                    className={`ast-filter-btn ${!activeCategory ? 'ast-filter-btn--active' : ''}`}
                    onClick={() => onCategoryChange(null)}
                >
                    {t('catalog.allCategories')}
                </button>
                {categories.map((cat) => (
                    <button
                        key={cat.id}
                        className={`ast-filter-btn ${activeCategory === cat.id ? 'ast-filter-btn--active' : ''}`}
                        onClick={() => onCategoryChange(cat.id)}
                    >
                        {cat.name}
                    </button>
                ))}
            </div>
        </div>
    );
}
